import { Seo } from '../components/Seo';

export function ContactPage() {
  return (
    <section className="stack-md">
      <Seo title="타로맨스 | Contact" description="타로맨스 연락처와 위치 안내" />
      <article className="card">
        <h1>Contact</h1>
        <p>전화: 0507-1361-9410</p>
        <p>주소: 서울특별시 강남구 도곡로 11길 10 1층</p>
        <p>운영시간: OPEN 17:00 / CLOSE 03:00 (연중무휴)</p>
        <p>타로상담 가능: 일~금 19:00 - 03:00 / 토요일 타로상담 불가</p>
      </article>
      <article className="card">
        <h2>문의 채널</h2>
        <p>방문 전 예약/문의는 전화로 가장 빠르게 안내받으실 수 있습니다.</p>
        <p>19:00 이전 상담 문의는 오너 스케줄 확인 후 별도 안내될 수 있습니다.</p>
      </article>
    </section>
  );
}
